<template>
	<component
		:is="tag"
		:class="[
			settings.fixedClasses,
			settings.variants[variant],
			settings.icons[icon],
			computedIconSize,
			computedColor,
			computedBackgroundColor,
			groupHover ? `group-hover:${groupHover}` : null,
			groupFocus ? `group-focus:${groupFocus}` : null,
		]"
		aria-hidden="true"
	/>
</template>

<script></script>

<script setup>
import {computed} from 'vue';
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkIcon');

const props = defineProps({
	tag: {
		type: String,
		default: 'span',
		required: false,
	},
	size: {
		type: String,
		default: 'lg',
		required: false,
	},
	icon: {
		type: String,
		required: true,
	},
	variant: {
		type: String,
		default: 'default',
		required: false,
	},
	backgroundColor: {
		type: Boolean,
		required: false,
		default: false,
	},
	inline: {
		type: Boolean,
		default: true,
		required: false,
	},
	groupHover: {
		type: [String, Boolean],
		default: 'text-current',
		required: false,
	},
	groupFocus: {
		type: [String, Boolean],
		default: 'text-current',
		required: false,
	},
	color: {
		type: String,
		default: null,
		required: false,
	},
});

const computedIconSize = computed(() => {
	if (props.inline) {
		return 'text-[1.5em]';
	}
	return settings.sizes[props.size];
});

const computedColor = computed(() => {
	if (!props.color) {
		return null;
	}
	return settings.iconColors[props.color];
});
const computedBackgroundColor = computed(() => {
	if (!props.backgroundColor || !props.color) {
		return null;
	}
	return settings.surfaceColors[props.color];
});
</script>
